;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { RefreshToken } from '@qogita/canary-client'
import { browserLogger } from 'src/core/logger/browser'
import { AUTH_QUERY_KEYS } from 'src/deprecated/api/auth-queries'
import {
  REFRESH_SESSION_STALE_TIME,
  THIRTY_SECONDS,
} from 'src/deprecated/constants/time'
import { queryClient } from 'src/deprecated/contexts/QueryClient'

const getTokenTimeToExpireInMs = (token: string) => {
  const tokenPayload = token.split('.')[1] || ''
  const decodedTokenPayload = atob(tokenPayload)
  // oxlint-disable-next-line typescript/consistent-type-assertions -- grandfathered: deprecated-misc
  const jsonPayload = JSON.parse(decodedTokenPayload) as { exp: number }
  const timeToExpire = jsonPayload.exp * 1000 - Date.now()
  return timeToExpire
}

/**
 * Grace period for access token should always be less than the refresh token stale time.
 * Because we expect to get a new access token before the old one expires.
 */
const ACCESS_TOKEN_GRACE_PERIOD = REFRESH_SESSION_STALE_TIME - THIRTY_SECONDS

const getIsAccessTokenValid = (token: string) => {
  try {
    return getTokenTimeToExpireInMs(token) > ACCESS_TOKEN_GRACE_PERIOD
  } catch {
    return false
  }
}

export const getAccessToken = async () => {
  try {
    let token =
      queryClient.getQueryData<RefreshToken>(AUTH_QUERY_KEYS)?.accessToken

    if (!getIsAccessTokenValid(token || '')) {
      await queryClient.refetchQueries(
        {
          queryKey: AUTH_QUERY_KEYS,
          exact: true,
        },
        {
          cancelRefetch: false, // avoid duplicated requests
        },
      )
      token =
        queryClient.getQueryData<RefreshToken>(AUTH_QUERY_KEYS)?.accessToken
    }
    return token || ''
  } catch (error) {
    browserLogger.error(error, { event: 'get_access_token_error' })
    return ''
  }
}
